import styled from 'styled-components';
import { PALETTE } from '../../fields.constants';

const DEEP_AMBER = '#5E4104';

export const Box = styled.div`
  margin-top: 11px;
  padding: 11px 12px;
  font-size: 12.5px;
  line-height: 1.5;
  color: ${PALETTE.lateText};
  background: ${PALETTE.lateTagBg};
  border: 1px solid ${PALETTE.lateBorder};
  border-radius: 6px;

  b {
    font-weight: 700;
    color: ${DEEP_AMBER};
  }
`;

export const Heading = styled.b`
  display: block;
  margin-bottom: 3px;
  font-size: 13.5px;
`;

export const Row = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 11px;
`;

const button = `
  padding: 7px 13px;
  font-size: 12.5px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const Go = styled.button`
  ${button}
  color: #fff;
  background: ${PALETTE.brand};
  border: none;

  &:hover:not(:disabled) {
    background: ${PALETTE.brandDark};
  }
`;

export const Ghost = styled.button`
  ${button}
  color: ${PALETTE.lateText};
  background: #fff;
  border: 1px solid ${PALETTE.lateBorder};

  &:hover:not(:disabled) {
    background: ${PALETTE.lateBg};
  }
`;

export const ErrorNote = styled.p`
  margin: 8px 0 0;
  color: #b3261e;
`;

export const Link = styled.button`
  margin-top: 11px;
  padding: 0;
  font-size: 13px;
  font-weight: 500;
  color: ${PALETTE.brandDark};
  text-decoration: underline;
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    color: ${PALETTE.brand};
  }
`;
